import { createHikoAuthSync } from "@repo/shopify/utils/hiko";

import { caaRequest } from "@lib/caaClient";
import hikoSession, { HIKO_LOGIN_PROVIDER_KEY } from "@lib/hikoHeadlessSession";

import { useCustomerStore } from "@store/customer";

/** jp 스토어의 hiko 로그인 반영 (탈퇴요청 차단 등 공통 로직은 @repo/shopify/utils/hiko) */
export const { acceptLogin: acceptHikoLogin, syncOnBoot: syncHikoSessionOnBoot } = createHikoAuthSync({
  session: hikoSession,
  request: caaRequest,
  getToken: () => useCustomerStore.getState().caaToken,
  setToken: (caaToken) => {
    useCustomerStore.getState().loginCaa(caaToken);
  },
  clearToken: () => {
    useCustomerStore.getState().logout();
  },
  setCustomer: (customer) => {
    useCustomerStore.getState().updateCaa(customer);
  },
  // SocialLoginCaa가 클릭 시점에 기록해둔 로그인 provider를 store에 영구 반영
  onAccepted: () => {
    const provider = sessionStorage.getItem(HIKO_LOGIN_PROVIDER_KEY);
    if (provider) {
      useCustomerStore.getState().setCaaLoginProvider(provider);
      sessionStorage.removeItem(HIKO_LOGIN_PROVIDER_KEY);
    }
  },
});
